'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormattedHTMLMessage = require('I18n/components/FormattedHTMLMessage');

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _UIDialogBody = require('UIComponents/dialog/UIDialogBody');

var _UIDialogBody2 = _interopRequireDefault(_UIDialogBody);

var _UIDialogCloseButton = require('UIComponents/dialog/UIDialogCloseButton');

var _UIDialogCloseButton2 = _interopRequireDefault(_UIDialogCloseButton);

var _UIModal = require('UIComponents/dialog/UIModal');

var _UIModal2 = _interopRequireDefault(_UIModal);

var _PriceTiers = require('./PriceTiers');

var _PriceTiers2 = _interopRequireDefault(_PriceTiers);

var _ContactsSelectors = require('pricing-pages-unified-ui/selectors/ContactsSelectors');

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var _CurrencySelector = require('./CurrencySelector');

var _CurrencySelector2 = _interopRequireDefault(_CurrencySelector);

var _EnvironmentWrapper = require('pricing-pages-unified-ui/components/EnvironmentWrapper');

var _EnvironmentWrapper2 = _interopRequireDefault(_EnvironmentWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactsConfirmationModal = function ContactsConfirmationModal(_ref) {
  var currencyCode = _ref.currencyCode,
      numContactsInCrm = _ref.numContactsInCrm,
      handleModalClose = _ref.handleModalClose,
      termId = _ref.termId;
  return _react2.default.createElement(
    _UIModal2.default,
    { width: 600, use: 'conversational', onOverlayClick: handleModalClose },
    _react2.default.createElement(_UIDialogCloseButton2.default, { onClick: handleModalClose }),
    _react2.default.createElement(
      _UIDialogBody2.default,
      null,
      _react2.default.createElement(
        'h1',
        null,
        _react2.default.createElement(_FormattedMessage2.default, { message: 'contactConfirmation.contactTierPricingModal.modalTitle' })
      ),
      _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(_FormattedMessage2.default, { message: 'contactConfirmation.contactTierPricingModal.modalDescription' })
      ),
      _react2.default.createElement(_EnvironmentWrapper2.default, {
        authedNode: _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(_FormattedHTMLMessage2.default, {
            message: 'contactConfirmation.contactTierPricingModal.currentContactsInCrm',
            options: { contacts: numContactsInCrm }
          })
        ),
        publicNode: null
      }),
      _react2.default.createElement(
        'div',
        { className: 'text-right' },
        _react2.default.createElement(_CurrencySelector2.default, null)
      ),
      _react2.default.createElement(_PriceTiers2.default, {
        merchId: _MerchandiseIds.PRODUCT_MARKETING_STARTER_CONTACTS,
        termId: termId,
        currencyCode: currencyCode
      })
    )
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    numContactsInCrm: (0, _ContactsSelectors.numContactsInCrmSelector)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ContactsConfirmationModal);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/contacts-confirmation-page/ContactConfirmationModal.js
// module id = 669
// module chunks = 3 4